<span>
  <div [class]="'hub-status-wrapper '">
    <div [class]="'hub-status ' + statusClassName">
      <span>{{ statusLabel }}</span>
    </div>
  </div>
</span>
